import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { BlogPostSeo } from '../Seo/BlogSeo';
import { getPostBySlug } from '../../data/blogPosts';
import './HousingReformWave.css';

/**
 * Interactive field note — mounts the design HTML (D3 scrollytelling).
 * Crawlable GEO summary sits outside the iframe for search / AI citation.
 * See docs/BLOG_PAGE.md
 */
export default function HousingReformWave({ post: postProp }) {
  const post = postProp || getPostBySlug('the-2026-housing-reform-wave');

  return (
    <div className="housing-reform-wave">
      <BlogPostSeo post={post} />
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:ital,wdth,wght@0,62..125,100..900;1,62..125,100..900&family=Newsreader:ital,opsz,wght@0,6..72,300..600;1,6..72,300..600&family=IBM+Plex+Mono:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <article className="housing-reform-wave__seo">
        <p>
          <Link to="/blog">← Construx Blog</Link>
        </p>
        <h1>{post.title}</h1>
        <p>{post.lede}</p>
        <p>
          Source: AEI Housing Center, &ldquo;2026 State Housing Supply Legislation
          Update&rdquo; (Ed Pinto), June 2, 2026. Construx analysis — not advocacy.
        </p>
        {post.geoSummary?.length ? (
          <section>
            <h2>Key findings</h2>
            <ul>
              {post.geoSummary.map((fact) => (
                <li key={fact.slice(0, 48)}>{fact}</li>
              ))}
            </ul>
          </section>
        ) : null}
        <p>
          Interactive chapters cover the national map, status funnel, policy
          mechanisms, KISS process reforms, featured state stories, a scenario lab,
          and the full bill explorer.
        </p>
      </article>

      <iframe
        className="housing-reform-wave__frame"
        title="The 2026 Housing Reform Wave — Construx Industry Analysis"
        src="/blog/reform-wave/index.html"
        allow="fullscreen"
      />
    </div>
  );
}
